import swal from "sweetalert2";
import AdminApi from "../../services/api";
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";
import {integer} from "vee-validate/dist/rules.esm";
import COMPANIES from "../../services/ListCompany";


const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            role: '',
            locale: LocService,
            tabsOnHomePage: '',
            selectedImage: null,
            selectedHeaderImagePreview: null,
            imageHeaderUrl: null,
            notifications: [],
            trainings: [],
            trainers: [],
            shops: [],
            shopsActions: [],
            events: [],
            nutritions: [],
            knowledges: [],
            allCustomCategories: [],
            selectedCustomCategories: [],
            selectedButton: 'NOTIFICATIONS',
            showNoNotification: false,
            showNotification: false,
            showDialogApp: false,
            isEnableBusyProgress: false,
            appHeaderByLocation: null,
            enableShopAndOrder: false,
            progressValue: 0,
            mdMode: 'indeterminate',
            showQrCodeItem: null,
            enableAddNotification: false,
            qrScannerFocusEnabled: CONFIG_COMPANY.USE_QR_SCANNER_FOCUS != null ? CONFIG_COMPANY.USE_QR_SCANNER_FOCUS : false,
            isFocusedScanner: false,
            scannerData: '',
            lastScannerRead: '',
            scannerFocusIntervalId: null,
            isFullscreen: false
        }
    },
    methods: {
        getNotifications: getNotifications,
        isAdmin: isAdmin,
        openCompanyInfoInfo: openCompanyInfoInfo,
        editCompanyInfo: editCompanyInfo,
        tryParse: tryParse,
        buyShopItem: buyShopItem,
        showQrCodeForItem: showQrCodeForItem,
        makeAction: makeAction,
        orderShopItem: orderShopItem,
        deleteCompanyInfo: deleteCompanyInfo,
        hideCompanyInfo: hideCompanyInfo,
        deletePhoto: deletePhoto,
        setAppHeaderImage: setAppHeaderImage,
        getBusyProgress: getBusyProgress,
        getImageForIntesity: getImageForIntesity,
        signUpForEvent: signUpForEvent,
        allEventItems: allEventItems,
        getMaxChars: getMaxChars,
        isSelected: isSelected,
        getChipClass: getChipClass,
        clickSelectCustomCategory: clickSelectCustomCategory,
        loadTextFromFile: loadTextFromFile,
        convertAdditionalInfo: convertAdditionalInfo,
        deleteNotification: deleteNotification,
        uploadPhoto: uploadPhoto,
        editNotification: editNotification,
        getStyle: getStyle,
        getConfig: getConfig,
        isLink: isLink,
        detectAgent: detectAgent,
        displayDate: displayDate,
        close: close,
        getText: getText,
        getTitle: getTitle,
        getProgressStyle: getProgressStyle,
        getDiscountPrice: getDiscountPrice,
        getMonthDisplay: getMonthDisplay,
        isSimpleText: isSimpleText,
        onTabClicked: onTabClicked,
        loadImageByLocation: loadImageByLocation,
        loadImageByLocationFromApi: loadImageByLocationFromApi,
        getButtonText: getButtonText,
        getCompanyInfoLong: getCompanyInfoLong,
        getCompanyInfoShort: getCompanyInfoShort,
        getCompanyInfoName: getCompanyInfoName,
        previewKnowledge: previewKnowledge,
        copyToNotification: copyToNotification,
        isButton: isButton,
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
        isLoggedIn() {
            return session.getAccessToken() !== null && session.getAccessToken().length > 0
        },
        loadUser() {
            if(localStorage.getItem('ACCESS_TOKEN') == null) return;
            AdminApiService.getProfile()
                .then((response) => {
                })
                .catch(error => {
                    swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
                })
        },
        openTerms:openTerms,
        onScannerFocus() {
            this.isFocusedScanner = true;
        },
        onScannerBlur() {
            this.isFocusedScanner = false;
        },
        async toggleScannerFocus() {
            if (this.isFocusedScanner) return;
            // todo za sada necemo fullscreen
            // await this.requestFullscreen(this.$refs.scannerContainer);
            this.$nextTick(() => this.$refs.scannerInput.focus());
        },
        onScannerEnter() {
            this.lastScannerRead = (this.scannerData || '').trim();
            let username = this.lastScannerRead;
            if (username.toLowerCase().startsWith("u_")) {
                username = username.substring(2);
                this.lastScannerRead = username;
                this.$topnavbar.$emit('reserveQrTraining', username);
            }
            this.scannerData = '';
            // ostani spreman za sledeći sken
            this.$nextTick(() => this.$refs.scannerInput.focus());
        },
        ensureScannerFocus() {
            // radi samo ako: na home, dozvoljeno u configu, i NEMA fokusa
            if (!this.qrScannerFocusEnabled) return;
            if (this.isFocusedScanner) return;
            if (document.hidden) return;
            this.$nextTick(() => this.$refs.scannerInput.focus());
        },

        startScannerAutoFocus() {
            if (!this.qrScannerFocusEnabled) return;
            if (this.isMobile()) return;
            // već radi?
            if (this.scannerFocusIntervalId) return;

            // inicijalni pokušaj
            this.ensureScannerFocus();

            // na svakih 10 sec (10000 ms) vrati fokus
            this.scannerFocusIntervalId = window.setInterval(() => {
                console.log('Vracam fokus')
                this.ensureScannerFocus();
            }, 10000);

            // kad se tab vrati u fokus – odmah probaj
            document.addEventListener('visibilitychange', this._onVisibilityChange);
            window.addEventListener('focus', this._onWindowFocus);
        },

        stopScannerAutoFocus() {
            if (this.scannerFocusIntervalId) {
                clearInterval(this.scannerFocusIntervalId);
                this.scannerFocusIntervalId = null;
            }
            document.removeEventListener('visibilitychange', this._onVisibilityChange);
            window.removeEventListener('focus', this._onWindowFocus);
        },

        _onVisibilityChange() {
            if (!document.hidden) this.ensureScannerFocus();
        },
        _onWindowFocus() {
            this.ensureScannerFocus();
        },
        async requestFullscreen(el) {
            const target = el || this.$refs.scannerContainer;
            if (!target) return;

            try {
                if (target.requestFullscreen) {
                    await target.requestFullscreen();
                } else if (target.webkitRequestFullscreen) {
                    // Safari
                    await target.webkitRequestFullscreen();
                } else if (target.msRequestFullscreen) {
                    await target.msRequestFullscreen();
                }
                // uspešan ulazak će okinuti onFullscreenChange listener
            } catch (e) {
                // npr. odbijeno jer nije user gesture, ili browser blokira
                console.warn('Fullscreen request failed:', e);
            }
        },

        async exitFullscreen() {
            try {
                if (document.exitFullscreen) {
                    await document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                    await document.webkitExitFullscreen();
                } else if (document.msExitFullscreen) {
                    await document.msExitFullscreen();
                }
                // izlazak će okinuti onFullscreenChange
            } catch (e) {
                console.warn('Exit fullscreen failed:', e);
            }
        },

        onFullscreenChange() {
            const fsElement =
                document.fullscreenElement ||
                document.webkitFullscreenElement ||
                document.msFullscreenElement;

            this.isFullscreen = !!fsElement;

            // kad uđemo u fullscreen, odmah fokusiraj input
            if (this.isFullscreen) {
                this.$nextTick(() => this.$refs.scannerInput.focus());
            }
        },
        async toggleFullscreenOnly() {
            if (this.isFullscreen) {
                await this.exitFullscreen();
            } else {
                await this.requestFullscreen(this.$refs.scannerContainer);
            }
        },
    },
    mounted() {
        if(this.qrScannerFocusEnabled && !this.isMobile()){
            // Ako želiš auto-fokus pri učitavanju, otkomentariši:
            this.$nextTick(() => this.$refs.scannerInput.focus());
            this.startScannerAutoFocus();
            // todo za sada necemo fullscreen
            // document.addEventListener('fullscreenchange', this.onFullscreenChange);
            // document.addEventListener('webkitfullscreenchange', this.onFullscreenChange);
            // document.addEventListener('msfullscreenchange', this.onFullscreenChange);
        }
    },
    beforeDestroy() {
        // todo za sada necemo fullscreen
        // document.removeEventListener('fullscreenchange', this.onFullscreenChange);
        // document.removeEventListener('webkitfullscreenchange', this.onFullscreenChange);
        // document.removeEventListener('msfullscreenchange', this.onFullscreenChange);
        this.stopScannerAutoFocus();
    },
    computed: {
        displayValue() {
            return this.lastRead || '—';
        }
    },
    created() {
        let _self = this;
        this.$topnavbar.$on('closeShowQrCode', () => {
            _self.showQrCodeItem = null;
        });

        this.$topnavbar.$on('successReservedTraining', () => {
            _self.scannerData = ''
        });

    },
    beforeMount() {
        this.role = session.getRole();
        if(this.$route.query.selectedButton != null){
            this.selectedButton = this.$route.query.selectedButton;
        }

        this.getNotifications()
        this.detectAgent()
        this.getConfig();
        //TODO ovde ucitati sve appHeaderImageByLocation i napraviti mapu i na osnovu mape raditi sa slikama
        this.allCustomCategories = session.getConfig().customCategories.split(";").filter(e => e.length > 0);

        if(this.allCustomCategories.length > 0){
            this.selectedCustomCategories = [this.allCustomCategories[0]]
            this.loadImageByLocationFromApi();
        }else{
            this.imageHeaderUrl = session.getConfig().appHeaderImage
        }
        this.isEnableBusyProgress = session.getConfig().busyProgress > 0
        this.tabsOnHomePage = session.getConfig().tabsOnHomePage != null ? session.getConfig().tabsOnHomePage : '';
        this.enableShopAndOrder = session.getConfig().enableShopAndOrder != null ? session.getConfig().enableShopAndOrder : false;
        // this.progressValue = session.getConfig().busyProgress * 100
        if(!this.isLoggedIn()){
            this.$router.push('/login');
            return;
        }

        if(CONFIG_COMPANY.SPECIFIC_ROLES != null){
            if(CONFIG_COMPANY.SPECIFIC_ROLES[session.getUsername()] != null){
                if(CONFIG_COMPANY.SPECIFIC_ROLES[session.getUsername()].ENABLE_ADD_NOTIFICATION != null){
                    this.enableAddNotification = CONFIG_COMPANY.SPECIFIC_ROLES[session.getUsername()].ENABLE_ADD_NOTIFICATION;
                }
            }
        }else if(CONFIG_COMPANY.TRAINER_CAN_ADD_NOTIFICATION != null){
            this.enableAddNotification = CONFIG_COMPANY.TRAINER_CAN_ADD_NOTIFICATION
        }

        this.getBusyProgress();
        this.loadUser();
    }
}

function loadImageByLocationFromApi(){
    if(this.selectedCustomCategories.length === 0) return;
    let _self = this;
    AdminApiService.getAppHeaderByLocation()
        .then((response) => {
            _self.appHeaderByLocation = response.data.appHeaderImageByLocation;
            let config = session.getConfig();
            config.appHeaderImageByLocation = _self.appHeaderByLocation;
            session.saveConfig(config)
            if(_self.appHeaderByLocation != null && _self.selectedCustomCategories.length > 0){
                _self.imageHeaderUrl = _self.loadImageByLocation(_self.selectedCustomCategories[0])
            }
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function loadImageByLocation(location){
    let imageByLocations = this.appHeaderByLocation;
    if(imageByLocations == null || imageByLocations.length === 0) return null;
    var mainList = imageByLocations.split(";").filter(e => e.length > 0);
    var tempData = null;
    mainList.forEach(item => {
        if(item.includes(location)){
            var temp = item.split("->")
            if(temp.length > 1){
                if(temp[1] !== "null"){
                    tempData =  temp[1];
                }
            }
        }
    })
    return tempData;
}

function openCompanyInfoInfo(type){
    if(type === 'NOTIFICATIONS'){
        this.$router.push('/notification');
    }
    if(type === 'TRAINING'){
        this.$router.push('/add-training-company-info');
    }
    if(type === 'TRAINER'){
        this.$router.push('/add-trainer-company-info');
    }
    if(type === 'NUTRITION'){
        this.$router.push('/add-nutrition-company-info');
    }
    if(type === 'KNOWLEDGE'){
        this.$router.push('/add-knowledge-company-info');
    }
    if(type === 'SHOP'){
        this.$router.push('/add-shop-company-info');
    }

    if(type === 'EVENT'){
        this.$router.push('/add-event-company-info');
    }
}

function editCompanyInfo(id, type){
    if(type === 'NOTIFICATIONS'){
        this.$router.push('/notification');
    }
    if(type === 'TRAINING'){
        this.$router.push('/add-training-company-info?id='+ id);
    }
    if(type === 'TRAINER'){
        this.$router.push('/add-trainer-company-info?id='+ id);
    }
    if(type === 'NUTRITION'){
        this.$router.push('/add-nutrition-company-info?id='+ id);
    }
    if(type === 'KNOWLEDGE'){
        this.$router.push('/add-knowledge-company-info?id='+ id);
    }
    if(type === 'SHOP'){
        this.$router.push('/add-shop-company-info?id='+ id);
    }
    if(type === 'EVENT'){
        this.$router.push('/add-event-company-info?id='+ id);
    }
}

function makeAction(id) {
    this.$router.push('/add-shop-company-info?id='+ id + "&action=true");
}

function onTabClicked(type){
    this.selectedButton = type
}

function editNotification(id){
    this.$router.push('/notification?id='+id);
}

function getConfig(){
    if(!session.shouldFetchConfig()) {
        this.showNotification = session.getConfig().showNotificationOnHome
        this.showDialogApp = session.getConfig().shouldAskToDownloadApps
        this.getNotifications()
        this.detectAgent()
        return;
    }
    let _self = this;
    AdminApiService.getCompanyConfiguration(CONFIG_COMPANY.NAME)
        .then((response) => {
            session.saveConfig(response.data)
            session.setLastFetchConfig();
            _self.showNotification = session.getConfig().showNotificationOnHome
            _self.showDialogApp = session.getConfig().shouldAskToDownloadApps
            _self.getNotifications()
            _self.detectAgent()
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function detectAgent() {
    if(!this.showDialogApp) return;
    let androidUrl = session.getConfig().googlePlay;
    let aAndroid = '<a href=\"' + androidUrl +'\">';
    let iosUrl = session.getConfig().appStore;
    let aios = '<a href=\"' + iosUrl +'\">';
    if(navigator.userAgent.toString().includes("Android")){
        swal({
            title: LocService.t("label_download_app"),
            html : '<html><div class="foo">' +
                '<br>' +
                aAndroid +
                '<div class="dialog-google-play"></div>'+
                '</a>' +
                '<br>'+
                // '<a><u>Ne sada</u></a>'+
                '</div></html>',
            text: "",
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: LocService.t("label_not_now"),
            customClass: 'swal2-warning'
        }).then(function () {

        });
    }else if(navigator.userAgent.toString().includes("iPhone")){
        swal({
            title: LocService.t("label_download_app"),
            html : '<html><div class="foo">' +
                '<br>' +
                aios +
                '<div class="dialog-app-store"></div>'+
                '</a>' +
                '<br>'+
                // '<a><u>Ne sada</u></a>'+
                '</div></html>',
            text: "",
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: LocService.t("label_not_now"),
            customClass: 'swal2-warning'
        }).then(function () {

        });
    }
}

function close() {
    swal.close()
}

function getNotifications() {
    let _self = this;
    this.showNoNotification = false;

    AdminApiService.getAllForHomePage()
        .then((response) => {
            _self.notifications = response.data.notifications;
            _self.trainings = response.data.companyInfos.filter(e => e.type === 'TRAINING')
            _self.trainers = response.data.companyInfos.filter(e => e.type === 'TRAINER')
            _self.nutritions = response.data.companyInfos.filter(e => e.type === 'NUTRITION')
            _self.knowledges = response.data.companyInfos.filter(e => e.type === 'KNOWLEDGE')
            _self.shops = response.data.companyInfos.filter(e => e.type === 'SHOP')
            _self.events = response.data.companyInfos.filter(e => e.type === 'EVENT')
            _self.shops.forEach(e => {
                e.addInfo = _self.convertAdditionalInfo(e.additionalInfo)
                e.discountPrice = _self.getDiscountPrice(e.addInfo)
            })
            _self.shopsActions = _self.shops.filter(e => e.discountPrice.length > 0)
            _self.shops = _self.shops.filter(e => e.discountPrice.length === 0)

            _self.showNoNotification = _self.notifications.length === 0;
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function getStyle(notification) {
    if(notification.priority === 'LOW'){
        return "background-color: #7CB450;"
    }else if(notification.priority === 'MEDIUM'){
        return "background-color: #C9BE5B;"
    } else if(notification.priority === 'HIGH'){
        return "background-color: #D06B6B;"
    }
}


function deleteNotification(notification) {
    let _self = this;
    swal({
        title: LocService.t("label_are_you_sure"),
        text: LocService.t("label_are_you_sure_delete_notification"),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t("label_no"),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t("label_yes"),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deleteNotifications(notification.id)
            .then((response) => {
                _self.getNotifications()
                swal(LocService.t("label_success"),LocService.t("label_success_delete_notification"), 'success')
            })
            .catch(error => {
                swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })
    });



}

function isLink(text) {
    return (text.includes('http') || text.includes('www')) && !text.includes('<-dugme->')
}

function isSimpleText(text) {
    return !text.includes('http') && !text.includes('www') && !text.includes('<-dugme->')
}

function isButton(text) {
    return text.includes('<-dugme->')
}

function onButtonClicked(text) {
    let temp = text.split('<-dugme->')[1]
    window.open(temp, "_blank");
}

function getButtonText(text) {
    return text.split('<-dugme->')[0]
}

function openTerms(){
    this.$router.push('/terms');
}


function displayDate(timestamp){
    let date = this.$moment(new Date(timestamp)).format('DD-MM')
    let temp = date.split("-")
    return {
        day: parseInt(temp[0]).toString(),
        month: this.getMonthDisplay(temp[1])
    }
}

function getMonthDisplay(month) {
    switch (month) {
        case '01': return this.locale.t("month_short_january");
        case '02': return this.locale.t("month_short_february");
        case '03': return this.locale.t("month_short_march");
        case '04': return this.locale.t("month_short_april");
        case '05': return this.locale.t("month_short_may");
        case '06': return this.locale.t("month_short_june");
        case '07': return this.locale.t("month_short_july");
        case '08': return this.locale.t("month_short_august");
        case '09': return this.locale.t("month_short_september");
        case '10': return this.locale.t("month_short_october");
        case '11': return this.locale.t("month_short_november");
        case '12': return this.locale.t("month_short_december");
        default: return this.locale.t("month_short_january");
    }
}

function getText(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.text;
    }else if(item.enText != null && item.enText.length > 0){
        return  item.enText;
    }
    return item.text;
}


function getTitle(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.title;
    }else if(item.enTitle != null && item.enTitle.length > 0){
        return  item.enTitle;
    }
    return item.title;
}


function getCompanyInfoName(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.name;
    }else if(item.enName != null && item.enName.length > 0){
        return  item.enName;
    }
    return item.name;
}

function getCompanyInfoShort(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.shortDescription;
    }else if(item.enShortDescription != null && item.enShortDescription.length > 0){
        return  item.enShortDescription;
    }
    return item.shortDescription;
}

function getCompanyInfoLong(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.longDescription;
    }else if(item.enLongDescription != null && item.enLongDescription.length > 0){
        return  item.enLongDescription;
    }
    return item.longDescription;
}

function getBusyProgress(){
    if(!this.isEnableBusyProgress) return
    let _self = this;
    AdminApiService.getBusyProgress()
        .then((response) => {
            console.log(response.data.busyPercent)
            _self.progressValue = (response.data.busyPercent * 10)
            _self.mdMode = 'determinate'

        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function getProgressStyle(){
    var style = "width: "+ this.progressValue + "%;";
    if(this.progressValue < 33){
        style += "background-color: #7CB450; color: #083954;"
    }else if(this.progressValue >= 33 && this.progressValue <= 70){
        style += "background-color: #C9BE5B; color: #083954;"
    }else {
        style += "background-color: #D06B6B; color: #083954;"
    }
    return style;
}


function getMaxChars(str, maxChars) {
    if(str == null) return ''
    // Provera da li je ulazni string duži od maksimalnog broja karaktera
    if (str.length > maxChars) {
        // Ako jeste, vraćamo prvih maxChars karaktera
        return str.substring(0, maxChars);
    } else {
        // Ako nije, vraćamo ceo ulazni string
        return str;
    }
}

function convertAdditionalInfo(additionalInfo){
    return JSON.parse(additionalInfo)
}

function getDiscountPrice(addInfo) {
    if(addInfo == null) return ""
    if(addInfo.discount == null) return ""
    try {
        const discountPrice = addInfo['discount'] != null ? parseInt(addInfo['discount']) : 0;
        const price = addInfo['price'] != null ? parseFloat(addInfo['price']) : 0.0;
        return (price - price * (discountPrice / 100)).toFixed(2);
    } catch (e) {
        console.log("ERROR " + e.toString());
        return "";
    }
}

function tryParse(data) {
    try {
        parseInt(data, 10)
    } catch (e) {
        return 0;
    }
}

function getImageForIntesity(value){
     return  require('../../assets/img/icons/infos/training/intesity_'+value+'.svg')
}

function deleteCompanyInfo(id, name) {
    let _self = this;
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_ci_training_are_you_sure') + name,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deleteCompanyInfo(id)
            .then((response) => {
                _self.getNotifications()
            })
            .catch(error => {
                swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });
}

function hideCompanyInfo(id) {
    let _self = this;
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {
    });
    AdminApiService.hideCompanyInfo(id)
        .then((response) => {
            swal.close();
            _self.getNotifications()
        })
        .catch(error => {
            swal.close();
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function isAdmin(){
    return session.getRole() === 'ROLE_ADMIN' || session.getRole() === 'ROLE_SUPER_ADMIN'
}


function uploadPhoto() {
    if(this.selectedImage == null) return;
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {});
    let _self = this;
    AdminApiService.uploadImageCompanyInfo(this.selectedImage)
        .then((response) => {
            _self.setAppHeaderImage(response.data.url)
            // swal(LocService.t('label_success'), LocService.t('label_ci_header_image_uploaded_success'), 'success')
        })
        .catch((error) => {
            swal(LocService.t('label_error'), LocService.t('label_image_upload_error'), 'error')
        })
}

function setAppHeaderImage(url){
    let _self = this;
    let model = {
        url: url,
        location: _self.selectedCustomCategories.length > 0 ? _self.selectedCustomCategories[0] : null
    }
    AdminApiService.updateAppHeaderImage(model)
        .then((response) => {
            let config = session.getConfig();
            config.appHeaderImage = url;
            session.saveConfig(config)
            _self.imageHeaderUrl = url;
            _self.loadImageByLocationFromApi();
            swal(LocService.t('label_success'), LocService.t('label_ci_header_image_uploaded_success'), 'success')
        })
        .catch((error) => {
            swal(LocService.t('label_error'), LocService.t('label_image_upload_error'), 'error')
        })
}


function loadTextFromFile(ev) {
    var i = 0;
    for (i = 0; i < ev.target.files.length; i++) {
        const file = ev.target.files[i];
        if (file.size > 5000000) {
            alert(this.locale.t('label_max_size_picture'))
            return
        }
        const reader = new FileReader();
        this.selectedImage = file;
        this.selectedHeaderImagePreview = URL.createObjectURL(file);
        reader.onload = e => {
            // console.log(e.target.result);
            // _self.files.push(e.target.result);
        }

        reader.readAsDataURL(file);

    }
}

function deletePhoto(){
    let _self = this;
    if(_self.imageHeaderUrl == null){
        _self.selectedImage = null;
        _self.selectedHeaderImagePreview = null;
        this.$refs.fileInput1.value = null;
        return;
    }
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_ci_header_photo_delete_are_you_sure') + name,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        _self.selectedImage = null;
        _self.selectedHeaderImagePreview = null;
        _self.imageHeaderUrl = null;
        _self.$refs.fileInput1.value = null;
        let model = {
            url: null,
            location: _self.selectedCustomCategories.length > 0 ? _self.selectedCustomCategories[0] : null
        }
        console.log(_self.selectedCustomCategories[0])
        AdminApiService.updateAppHeaderImage(model)
            .then((response) => {
                let config = session.getConfig();
                config.appHeaderImage = model.url;
                session.saveConfig(config)
                _self.imageHeaderUrl = model.url;
                _self.selectedHeaderImagePreview = null;
                _self.selectedImage = null;
                _self.loadImageByLocationFromApi();
                swal(LocService.t('label_success'), LocService.t('label_ci_header_image_uploaded_success'), 'success')
            })
            .catch((error) => {
                swal(LocService.t('label_error'), LocService.t('label_image_upload_error'), 'error')
            })
    });


}

function getChipClass(item) {
    if (this.selectedCustomCategories.includes(item)) {
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelected(item) {
    return this.selectedCustomCategories.includes(item)
}

function clickSelectCustomCategory(item) {
    if (this.selectedCustomCategories.includes(item)) {
        // this.selectedCustomCategories = []
    } else {
        this.selectedCustomCategories = []
        this.selectedCustomCategories.push(item)
        this.selectedHeaderImagePreview = null;
        this.selectedImage = null;
        this.imageHeaderUrl = this.loadImageByLocation(item)

    }
}

function buyShopItem(item){
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_are_you_sure_buy_item') + this.getCompanyInfoName(item) + ' ? ',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.buyProduct(item.orderUuid)
            .then((response) => {
                swal(LocService.t('label_success'), LocService.t('label_successfully_bought_item'), 'success')
            })
            .catch((error) => {
                swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });
}


function orderShopItem(item){
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_are_you_sure_order_item') + this.getCompanyInfoName(item) + ' ? ',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.orderProduct(item.orderUuid)
            .then((response) => {
                swal(LocService.t('label_success'), LocService.t('label_successfully_ordered_item'), 'success')
            })
            .catch((error) => {
                swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });
}

function showQrCodeForItem(item){
    this.showQrCodeItem = item
}

function signUpForEvent(event){
    this.$router.push('/sign-up-for-event?id=' + event.id + "&name=" + event.name + '&programToken='+session.getAccessToken());
}

function allEventItems(event){
    this.$router.push('/all-event-items?id=' + event.id + "&name=" + event.name);
}

function previewKnowledge(item){
    window.open('http://localhost:3010/#/knowledge-details?id=' + item.id + '&programToken='+session.getAccessToken(), '_blank');
    // this.$router.push('/knowledge-details?id=' + item.id);
}

function copyToNotification(item){
    this.$router.push('/notification?companyInfoId='+item.id);
}



// WEBPACK FOOTER //
// ./src/components/Home/HomePage.js